Vue.component('meal-report', {

    props: {
        'trans': {
            type: Object
        },
        'selectedPeriod': {
            type: String
        },
        'contractTypes': {
            type: Array
        },
        'socialFundDefault': {
            type: String
        },
        'reserveCountDefault': {
            type: String
        },
        'reserveValueDefault': {
            type: String
        },
    },

    data() {
        return {
            form: {
                period: this.selectedPeriod,
                contractTypes: this.contractTypes,
                socialFund: this.socialFundDefault,
                reserveCount: this.reserveCountDefault,
                reserveValue: this.reserveValueDefault,
                loading: false
            },
            infopanel: {
                show: false,
                type: "danger",
                icon: "exclamation-circle",
                message: ""
            },
            errorsModal: {
                title: "",
                errors: []
            },
        };
    },

    methods: {

        validateForm(evt)
        {
            this.form.loading = true;
            this.infopanel.show = false;

            if(this.form.contractTypes.length === 0) {
                this.showError(evt, "no_contract_type");
            }

            if(!this.form.period) {
                this.showError(evt, "no_period");
            }

            setTimeout(() => {
                this.form.loading = false;
            }, 3000);

            return true;
        },

        showError(evt, key)
        {
            evt.preventDefault();

            this.form.loading = false;
            this.infopanel.show = true;
            this.infopanel.message = this.trans.messages[key];
        }
    }

});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/import-export/meal-report.js